import styled from "@emotion/styled";

import { fontMerriweather, fontRoboto, fontRobotoCondensed } from "shared/lib/styles";

import { pageStyle } from "scmp-app/components/article/article-render/article-content/print-article-styles";
import { PrintArticleAuthorBlock } from "scmp-app/components/article/article-render/print-article/author-block";
import { PrintArticleFooter } from "scmp-app/components/article/article-render/print-article/footer";
import { PrintArticleMainImage } from "scmp-app/components/article/article-render/print-article/main-image";
import { PrintArticlePaywall } from "scmp-app/components/article/article-render/print-article/paywall";
import { ArticleSections } from "scmp-app/components/article/article-sections";
import { SectionLink, SectionText } from "scmp-app/components/article/article-sections/styles";
import { ArticleSourceHeader } from "scmp-app/components/article/article-source-header";
import { ContentHeadline } from "scmp-app/components/content/content-headline";
import { ContentSponsorTag } from "scmp-app/components/content/content-sponsor-tag";
import { ContentSubHeadline } from "scmp-app/components/content/content-sub-headline";
import { StyledLi, StyledUl } from "scmp-app/components/schema-render/content/styles";

export const StyledContentHeadline = styled(ContentHeadline)`
  margin-block-end: 16px;

  color: #000000;
  font-weight: 900;
  font-size: 16px;
  font-family: ${fontMerriweather};
  line-height: 22.4px;
`;

export const StyledContentSubHeadline = styled(ContentSubHeadline)`
  margin-block-end: 16px;

  font-size: 14px;
  font-family: ${fontRoboto};
  line-height: 16.4px;

  ${StyledUl} {
    padding-inline-start: 20px;
  }

  ${StyledLi} + ${StyledLi} {
    margin-block-start: 16px;
  }
`;

export const StyledContentSponsorTag = styled(ContentSponsorTag)`
  display: flex;
  flex-direction: row;

  margin-block-end: 16px;

  color: #000000;
  font-size: 11px;
  line-height: 12.9px;
`;

export const StyledPrintArticleAuthorBlock = styled(PrintArticleAuthorBlock)`
  margin-block-end: 16px;
`;

export const StyledArticleSections = styled(ArticleSections)`
  margin-block-end: 16px;

  ${SectionLink}, ${SectionText} {
    color: #000000;
    font-size: 14px;
    font-family: ${fontRobotoCondensed};
    line-height: 16.4px;
  }

  ${SectionLink}:last-child {
    color: #000000;
  }
`;

export const Body = styled.div`
  ${pageStyle()}
`;

export const StyledPrintArticleMainImage = styled(PrintArticleMainImage)`
  display: flex;

  max-inline-size: 700px;
  margin-block-end: 16px;
  padding-block: 10px;
  padding-inline: 0 80px;
`;

export const StyledArticleSourceHeader = styled(ArticleSourceHeader)`
  margin-block-end: 20px;
  border-block-end: 1px solid #000000;
`;

export const StyledPrintArticleFooter = styled(PrintArticleFooter)`
  margin-block: 20px;
  border-block-start: 1px solid #000000;
`;

export const StyledPrintArticlePaywall = styled(PrintArticlePaywall)`
  max-inline-size: 700px;
  margin-block-end: 16px;
`;
